<template>
  <b-modal
    id="modal-confirm-set-automation"
    class="mc-modal"
    title="Aktifkan Automasi Perjalanan?"
    header-bg-variant="primary"
    size="md"
    centered
  >
    <McAlert
      v-if="isSameOriginAndFirstDoPickup"
      variant="info"
      text="Titik Mulai sama dengan lokasi pengambilan DO pertama"
      withIcon
      :withGap="false"
    />

    <p v-if="message" class="mt-2 p-0" v-html="message"></p>

    <template #modal-footer>
      <McButton
        variant="secondary"
        class="me-2"
        :text="$t('global.action.cancel')"
        @click="$bvModal.hide('modal-confirm-set-automation')"
      />
      <McButton
        variant="primary"
        type="submit"
        :text="$t('global.action.activate')"
        @click="handleActivatedAutomation"
      />
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import McAlert from '@/components/McAlert'

export default {
  components: { McButton, McAlert },
  props: {
    foNumber: {
      type: String,
      default: null,
    },
    status: {
      type: String,
      default: null,
    },
    isSameOriginAndFirstDoPickup: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    message() {
      const fo = `<strong>${this.foNumber}</strong>`
      const keluar = `<strong>keluar dari Titik Mulai</strong>`
      const dijadwalkan = `<strong>Dijadwalkan</strong>`

      if (this.status === 'Draf') {
        return `Penugasan ${fo} akan dijalankan otomatis ketika kendaraan ${keluar} dan status akan berubah menjadi ${dijadwalkan}.`
      }

      if (this.status === 'Dijadwalkan' && this.isSameOriginAndFirstDoPickup) {
        return `Penugasan ${fo} akan dijalankan otomatis ketika kendaraan ${keluar}.`
      }

      return null
    },
  },
  methods: {
    handleActivatedAutomation() {
      this.$emit('set-automation')
      this.$bvModal.hide('modal-confirm-set-automation')
    },
  },
}
</script>
